<template>
  <form :id="formId" novalidate @submit.prevent="handleSubmit">
    <div>
      <label :for="`${formId}-name`" class="d-block caption">{{ $t('name') }}</label>
      <v-text-field
        :id="`${formId}-name`"
        v-model="form.name"
        v-validate="'required'"
        name="name"
        outline
        single-line
        :error-messages="errors.first('name')"
        :data-vv-as="$t('name')"
        :disabled="disabled"
      />
    </div>
  </form>
</template>

<script>
export default {
  props: {
    formId: {
      type: Boolean,
      default: undefined
    },
    value: {
      type: Object,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        name: '',
        ...this.value
      }
    }
  },
  methods: {
    async handleSubmit() {
      const valid = await this.$validator.validateAll()
      if (!valid) return
      this.$emit('submit', this.form)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/LonBroadcast/Category/Form.vue